module.exports = __webpack_public_path__ + "img/noted-icon.6427f9b5.svg";